import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

const TwitterNewIcon = ({ w = 24, h = 24, style, fill, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
      style={style}
      fill={fill}
    >
      <path
        d="M16.0761 5.67261H18.2229L13.5328 11.033L19.0503 18.3273H14.7302L11.3465 13.9034L7.4748 18.3273H5.32675L10.3432 12.5938L5.05029 5.67261H9.48009L12.5386 9.71627L16.0761 5.67261ZM15.3227 17.0424H16.5122L8.83373 6.89006H7.55722L15.3227 17.0424Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TwitterNewIcon;
